import { sharedLib } from "@shared/services/shared.service";
import { PaymentDetails, SubscriptionType } from "@shared/types";

interface usePaymentsProps {
  subscriptionType: SubscriptionType;
}

const usePayments = ({ subscriptionType }: usePaymentsProps) => {
  const { data: payments, isFetching } =
    sharedLib.sharedApi.settings.useGetRecentPaymentsQuery({
      subscription_type: subscriptionType,
    });

  const paymentsData = (payments || []).map((payment, index) => ({
    ...payment,
    key: index,
  }));

  const getPaymentDate = (payment: PaymentDetails) =>
    payment.update_timestamp ||
    payment.paid_timestamp ||
    payment.creation_timestamp;

  return {
    isFetching,
    paymentsData,
    getPaymentDate,
  };
};

export default usePayments;
